module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottomLinkModule"
  }, [_c('div', {
    staticClass: "bottomLinkMenu"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('ul', {
    staticClass: "account-nav"
  }, [_vm._l((_vm.bottomLinks), function(item, i) {
    return _c('li', {
      key: i,
      class: {
        current: item.id === _vm.linkId
      },
      on: {
        "click": function($event) {
          return _vm.tab(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }), _vm._v(" "), _c('li', {
    class: {
      current: -1 === _vm.linkId
    },
    on: {
      "click": function($event) {
        return _vm.tab(-1)
      }
    }
  }, [_vm._v("用户反馈")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "bottomLinkContent"
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }, [_vm._v(" ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee0cb01c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bottomLink/index.vue
// module id = 787
// module chunks = 2